
import { Purchase } from "@/models/base";
import Vue from "vue";
import AppInfoInput from "@/components/common/InfoInput.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Purchase,
			required: true
		}
	},
	components: {
		AppInfoInput
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
